module.exports = __webpack_public_path__ + "img/img_4.f303f74d.jpg";